import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import PlantillaScreen from "../helpers/PlantillaScreen";
import { LoaderScreen } from "../components/LoaderScreen";
import request from "../../Helpers/API";
import { NAV_ITEMS, GestionTIContext } from "./gestionti-constants";

// Layout persistente del módulo: header con el título, sidebar con perfil +
// navegación, y el contenido de la pantalla activa a la derecha. El rol se
// resuelve una sola vez aquí y se comparte al resto de las pantallas del
// módulo por contexto (GestionTIContext) para no repetir el fetch de
// RolTI/Mio en cada una.
export const GestionTILayout = ({ children }) => {
    const history  = useHistory();
    const location = useLocation();
    const { empleado } = useSelector((state) => state.usuario);

    const [rol, setRol]       = useState(null);
    const [loader, setLoader] = useState({ mostrar: true, alerta: false });

    useEffect(() => {
        request
            .get("RolTI/Mio")
            .then((result) => {
                setRol(result?.rol ?? "Usuario");
                setLoader({ mostrar: false, alerta: false });
            })
            .catch(() => {
                setRol("Usuario");
                setLoader({ mostrar: false, alerta: false });
            });
    }, []);

    const navVisibles = NAV_ITEMS.filter(
        (item) => !rol || item.roles.includes(rol)
    );

    return (
        <PlantillaScreen titulo="GESTIÓN TI" className="gestionti-screen">
            <div className="gestionti-layout">

                {/* ── Sidebar ──────────────────────────────────────────────── */}
                <aside className="gestionti-sidebar">
                    <div className="gestionti-sidebar-perfil">
                        <div className="gestionti-sidebar-avatar">
                            {empleado?.charAt(0)?.toUpperCase() ?? "U"}
                        </div>
                        <div className="gestionti-sidebar-info">
                            <div className="gestionti-sidebar-nombre">{empleado ?? "—"}</div>
                            <div className="gestionti-sidebar-rol">{rol ?? "Cargando…"}</div>
                        </div>
                    </div>

                    <nav className="gestionti-sidebar-nav">
                        {navVisibles.map((item) => {
                            const Icon     = item.icon;
                            const esActivo = location.pathname === item.ruta;
                            return (
                                <div
                                    key={item.key}
                                    className={[
                                        "gestionti-nav-item",
                                        esActivo          ? "gestionti-nav-item--activo"   : "",
                                        !item.activo      ? "gestionti-nav-item--disabled" : "",
                                    ].filter(Boolean).join(" ")}
                                    onClick={() => item.activo && history.push(item.ruta)}
                                    title={!item.activo ? "Próximamente" : item.label}
                                >
                                    <Icon className="gestionti-nav-icon" fontSize="small" />
                                    <span className="gestionti-nav-label">{item.label}</span>
                                    {!item.activo && (
                                        <span className="gestionti-nav-pronto">Próx.</span>
                                    )}
                                </div>
                            );
                        })}
                    </nav>
                </aside>

                {/* ── Contenido de la pantalla activa ─────────────────────── */}
                <main className="gestionti-content">
                    {loader.mostrar ? (
                        <LoaderScreen loader={loader} />
                    ) : (
                        <GestionTIContext.Provider value={{ rol, empleado, cargandoRol: false }}>
                            {children}
                        </GestionTIContext.Provider>
                    )}
                </main>

            </div>
        </PlantillaScreen>
    );
};
